enum COURSE_ACTIONS {
  FETCH_COURSES_LIST = 'FETCH_COURSES_LIST',
  FETCH_DIRECT_ACCESS_LIST = 'FETCH_DIRECT_ACCESS_LIST',
}

export default COURSE_ACTIONS;
